import React from 'react';
import styles from './style.module.css';
import SummaryForm from '../../components/forms/summary';

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Your Summary</h1>
        <p className={styles.text}>Review your income and expenses and make any necessary adjustments before moving on to the assessment.</p>
        <SummaryForm/>
    </div>
);
